export function createRoomRow(seed = {}) {
  return {
    id: seed.id ?? null,
    client_id: seed.client_id || `draft-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    onboarding_room_category_id: Number(seed.onboarding_room_category_id || 0),
    room_number: seed.room_number || "",
    floor: seed.floor ?? "",
    sq_meters: seed.sq_meters ?? "",
    num_beds: seed.num_beds ?? "",
    bed_type: seed.bed_type || "",
    view: seed.view || "",
    features: seed.features || "",
    description: seed.description || "",
  };
}

export function normalizeIncomingRows(rows = []) {
  return rows.map((row) =>
    createRoomRow({
      ...row,
      client_id: `server-${row.id}`,
    })
  );
}

export function buildCountsByCategory(categories, rooms) {
  const counts = {};

  categories.forEach((category) => {
    counts[category.id] = String(
      rooms.filter((room) => Number(room.onboarding_room_category_id) === Number(category.id)).length
    );
  });

  return counts;
}

export function normalizeCountInput(value) {
  return String(value ?? "").replace(/[^\d]/g, "");
}

export function parseCount(value) {
  const numericValue = Number(value);
  return Number.isInteger(numericValue) && numericValue > 0 ? numericValue : 0;
}

export function normalizeOptionalText(value) {
  return String(value || "").trim();
}

export function rowsHaveRequiredRoomNumbers(rows = []) {
  return Array.isArray(rows) && rows.length > 0 && rows.every((room) => normalizeOptionalText(room.room_number));
}

export function roomHasContent(room) {
  return [
    room.room_number,
    room.floor,
    room.sq_meters,
    room.num_beds,
    room.bed_type,
    room.view,
    room.features,
    room.description,
  ].some((value) => String(value ?? "").trim() !== "");
}

export function buildGeneratedRows(categories, currentRows, countsByCategory) {
  const nextRows = [];

  categories.forEach((category) => {
    const existingRows = currentRows.filter(
      (row) => Number(row.onboarding_room_category_id) === Number(category.id)
    );
    const targetCount = parseCount(countsByCategory[category.id]);
    const keptRows = existingRows.slice(0, targetCount);

    while (keptRows.length < targetCount) {
      keptRows.push(
        createRoomRow({
          onboarding_room_category_id: category.id,
        })
      );
    }

    nextRows.push(...keptRows);
  });

  return nextRows;
}

export function buildRowsPayload(rows) {
  return rows.map((row) => ({
    id: row.id || undefined,
    onboarding_room_category_id: row.onboarding_room_category_id,
    room_number: normalizeOptionalText(row.room_number) || null,
    floor: row.floor === "" ? null : Number(row.floor),
    sq_meters: row.sq_meters === "" ? null : Number(row.sq_meters),
    num_beds: row.num_beds === "" ? null : Number(row.num_beds),
    bed_type: normalizeOptionalText(row.bed_type) || null,
    view: normalizeOptionalText(row.view) || null,
    features: normalizeOptionalText(row.features) || null,
    description: normalizeOptionalText(row.description) || null,
  }));
}

export function pickCopyableData(room) {
  return {
    floor: room.floor ?? "",
    sq_meters: room.sq_meters ?? "",
    num_beds: room.num_beds ?? "",
    bed_type: room.bed_type || "",
    view: room.view || "",
    features: room.features || "",
    description: room.description || "",
  };
}

export function formatDate(dateValue) {
  if (!dateValue) return "Not applied yet";
  const parsed = new Date(dateValue);
  if (Number.isNaN(parsed.getTime())) return "Invalid date";
  return parsed.toLocaleString();
}
